import EditableTitle from './EditableTitle/index';
import ReportInfo from './ReportInfo';
import Table from './Table/container';
import PanelActions from './PanelActions';

export { EditableTitle, Table, ReportInfo, PanelActions };



// WEBPACK FOOTER //
// ./src/views/DashboardSettings_Slot/components/index.js